jQuery(document).ready(function($){

  
//check if element exists then run function  
if ( $( "videoreviews" ).length ) {
 showvideos('videoreviews'); 
}
  

  
function showvideos(targetdiv)  {   
  
// get element attributes to create variables for arguments
title = jQuery(targetdiv)[0].getAttribute("title");      
tag = jQuery(targetdiv)[0].getAttribute("tag");
limit = jQuery(targetdiv)[0].getAttribute("limit");
recordinglimit = jQuery(targetdiv)[0].getAttribute("recording-limit");  
recorderposition = jQuery(targetdiv)[0].getAttribute("recorder-position");   
videoclass = jQuery(targetdiv)[0].getAttribute("video-class");     
videoclassalt = jQuery(targetdiv)[0].getAttribute("video-class-alt");   
  
  
//create object to pass arguement in query to limit number of videos and only grab videos with unique tag 
  data = {limit:limit,tags:tag}  
  
  

ZiggeoApi.Videos.index(data, {
	success: function (args, videos) {
        
      
      
       $(targetdiv).prepend("<ul class='review-video-list clearfix'>");
      
    
      // videos is an array of all the videos
		// the following code dynamically adds all the videos to the page
       var n = 0;
		for (var i = 0; i < videos.length; ++i) {
         
          var name = videos[i].data.data[0].name;
          //var email = videos[i].data.data[0].email;
          var rating = videos[i].data.data[0].rating;
          var date = videos[i].data.data[0].date;
          
          
          //if statement argument to only return approved videos
         
          if(videos[i].approved == true) {    
            
            if(n > 2)  {
            $(targetdiv + ' ul').append("<li class='" + videoclassalt + "'><div class='flex-video'><ziggeo ziggeo-video='" + videos[i].token + "' ziggeo-effect_profile='_iphone' ziggeo-video_profile='_hd' ziggeo-responsive='true'></ziggeo><div class='info'><div class='columns large-12 medium-12 small-12'><h4 class='name'>" + name + "</h4><h5 class='date'>" + date + "</h5><div class='ratings' data-rating='" + rating + "'></div></div></div></div></li>");         
            }else{
            $(targetdiv + ' ul').append("<li class='" + videoclass + "'><div class='flex-video'><ziggeo ziggeo-video='" + videos[i].token + "' ziggeo-effect_profile='_iphone' ziggeo-video_profile='_hd' ziggeo-responsive='true'></ziggeo><div class='info'><div class='columns large-12 medium-12 small-12'><h4 class='name'>" + name + "</h4><h5 class='date'>" + date + "</h5><div class='ratings' data-rating='" + rating + "'></div></div></div></div></li>");          
            }
            ++n
          }	                
        }
      //end ul tag
      $(targetdiv).append("</ul>");
      
      $('.ratings').raty({ 
       readOnly: true, 
       score: function() {
    return $(this).attr('data-rating');
  }
      });
   
      
      //create recorder and position it 
       if(recorderposition == 'none') {
         
       }else{
      
     if(recorderposition == 'first') {
        //add unique tagged recorder and start ul tag
        $(targetdiv + ' ul').prepend("<li class='" + videoclass + "'><div class='flex-video recorder'><form action='javascript:void(0)'><div id='forminner'><h2>Record Your Video</h2><span class='subtitle'>20 second video from your phone or webcam</span><input id='title' name='title' type='text' placeholder='Your Name' /><input id='description' name='description' type='text' placeholder='Your Email' /><input id='ratingholder' type='hidden' value='5' name='rating' /><div class='submitrating' data-score='5'><span>Your Rating</span> </div><input type='submit' value='start recording' class='button' /></div></form><div><div id='video_recorder'></div></div></div></li>"); 
      }else{
        $(targetdiv + ' ul').append("<li class='" + videoclass + "'><div class='flex-video recorder'><form action='javascript:void(0)'><div id='forminner'><h2>Record Your Video</h2><span class='subtitle'>20 second video from your phone or webcam</span><input id='title' name='title' type='text' placeholder='Your Name' /><input id='description' name='description' type='text' placeholder='Your Email' /><input id='ratingholder' type='hidden' value='5' name='rating' /><div class='submitrating' data-score='5'><span>Your Rating</span> </div><input type='submit' value='start recording' class='button' /></div></form><div><div id='video_recorder'></div></div></div></li>"); 
      }
       }
      
      jQuery('div.submitrating').raty({
       score: function() {
         return $(this).attr('data-score');
       },
        targetScore: '#ratingholder'
      });
      
      
     jQuery('.flex-video.recorder form input[type=submit]').click(function() { 
      
       
       
       //collect data
       var name = $('.flex-video.recorder input#title').val();
       var email = $('.flex-video.recorder form input#description').val();
       var rating = $('.flex-video.recorder form input#ratingholder').val();
       var date = thedate();
       var data = {"data":[
         {"name":name, "email":email, "rating":rating,"date":date}
       ]};
       
       
       //send to klaviyo
       jQuery.post( "//manage.kmail-lists.com/subscriptions/subscribe", { g: "e8P2b8", email: email, first_name: name } );  
       
       
       //remove form overlay
       jQuery(this).closest('form').fadeOut('slow',function() {
       jQuery(this).closest('form').remove();
       });
       
       
      //create embedded recorder
       var embedding = ZiggeoApi.Embed.embed("#video_recorder", {title:title,tags:tag,limit:recordinglimit,modes:'recorder',responsive:true, disable_first_screen:true,immediate_playback:true,disable_device_test:true,video_profile:'_hd',recording_width:602,recording_height:800,effect_profile:'_iphone',data:data});  
     })
     
 
      
   jQuery('videoreviews ul li').bind('click', function() {
   jQuery(this).find('.info').remove();
    
    });  
      
      
	}
});
  
}  
  
//start date
function thedate() {
var today = new Date();
var dd = today.getDate();
var mm = today.getMonth()+1; //January is 0!
var yyyy = today.getFullYear();

if(dd<10) {
    dd='0'+dd
} 

if(mm<10) {
    mm='0'+mm
} 

today = mm+'/'+dd+'/'+yyyy;   
return today;
}
//end date  
  

  
  
  
  
  
//add success popup message			
ZiggeoApi.Events.on("submitted", function (data) {
  
  var name = data.data.data[0].name;
  var email = data.data.data[0].email;
  
   //send to klaviyo for finishing
   //jQuery.post( "//manage.kmail-lists.com/subscriptions/subscribe", { g: "evfRVw", email: email, first_name: name } );  
  
  
  $.fancybox("<div class='success-msg text-center'><h2>YASSS! we got your video!</h2><span>if your video gets approved You might see Your video on the site within 24-48 hours</span></div>");
  
});  
  
  
  
});   